export enum TrackingEvent {
  IconClick = `[UserIcon] Icon Click`,
}

export enum TrackingEventProperty {
  Source = `Source`, // example: report-header, signup, etc...
  AvatarType = `Avatar Type`,
  AccessPoint = `Access Point`,
  ResourceType = `Resource Type`,
  IconType = `Icon Type`,
}

export enum AvatarType {
  Empty = `empty`,
  Name = `name`,
  Photo = `photo`,
}

export interface TrackingEventProperties {
  [TrackingEventProperty.AvatarType]: AvatarType;
}

export function track(event: TrackingEvent, properties: TrackingEventProperties) {
  mixpanel.track(event, properties);
}

export type UserIconTrackProperties = {
  [TrackingEventProperty.Source]?: string;
  [TrackingEventProperty.AccessPoint]?: `views-overflow` | `creator-icon`;
  [TrackingEventProperty.IconType]?: `creator` | `viewer`;
  [TrackingEventProperty.ResourceType]?: `dashboard` | `report`;
};
